import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function ClosingSection() {
  return <section className="bg-charcoal text-cream py-20 md:py-32 px-4 border-t border-gold/20" data-id="element-1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-serif text-gold mb-10" data-id="element-4">
            Tienes dos caminos hoy.
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-cream/90 leading-relaxed mb-12" data-id="element-5">
            <p data-id="element-6">
              El primero es seguir como hasta ahora: trabajando duro pero sin un
              sistema, viendo cómo el tiempo y el dinero se te escapan de las
              manos.
            </p>
            <p data-id="element-7">
              El segundo es invertir el precio de una cena familiar en un
              sistema que puede cambiar tu legado para siempre.
            </p>
            <p className="font-serif text-2xl text-gold pt-6" data-id="element-8">
              Toma la decisión de ser un mayordomo excelente hoy mismo.
            </p>
          </div>

          <Button className="w-full md:w-auto md:px-12 md:py-6 text-xl mb-16" onClick={() => document.getElementById('pricing-cta')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })} data-id="element-9">
            SÍ, QUIERO EMPRENDER CON UNCIÓN — ACCESO INMEDIATO
          </Button>

          <footer className="text-sm text-cream/40 pt-8 border-t border-cream/10" data-id="element-10">
            <p data-id="element-11">
              © {new Date().getFullYear()} Emprender con Unción. Todos los
              derechos reservados.
            </p>
            <p className="mt-2" data-id="element-12">
              Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            </p>
          </footer>
        </motion.div>
      </div>
    </section>;
}